// ButtonLoad.tsx
import React, { FunctionComponent } from "react";
import styled from "styled-components";
import Button, { ButtonType, Text1, setBackgroundColor, getIconSize } from "./Button";
import Icon from "../global/Icon";

interface ButtonLoadProps extends ButtonType {
  progress?: number; // 0 to 1
  progressColor?: string;
}

const LoaderContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 1;
`;

const ProgressFill = styled.div.attrs<{ $progress: number; $fillBackground?: string }>(props => ({
  style: {
    width: `${Math.min(Math.max(props.$progress, 0), 1) * 100}%`,
  },
}))<{ $progress: number; $fillBackground?: string }>`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  background-color: ${({ $fillBackground }) => $fillBackground};
  transition: width 0.3s ease-out;
`;

const ContentOverlay = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: inherit;
  width: 100%;
  height: 100%;
`;

const ButtonLoad: FunctionComponent<ButtonLoadProps> = ({
  progress = 0,
  progressColor,
  text,
  icon,
  size = 'small',
  iconPosition = 'right',
  color = null,
  ...props
}) => {
  const iconSize = getIconSize(size);
  const finalProgressColor = progressColor || setBackgroundColor(color, 'default');

  return (
    <Button {...props} color={color} size={size} iconPosition={iconPosition} text={text} icon={icon}>
      <LoaderContainer>
        <ProgressFill $progress={progress} $fillBackground={finalProgressColor} />
      </LoaderContainer>
      
      <ContentOverlay>
        {iconPosition === 'left' ? (
          <>
            {icon && <Icon onClick={() => {}} icon={icon} color="inherit" size={iconSize} />}
            {text && <Text1 $color="inherit" $size={size}>{text}</Text1>}
          </>
        ) : (
          <>
            {text && <Text1 $color="inherit" $size={size}>{text}</Text1>}
            {icon && <Icon onClick={() => {}} icon={icon} color="inherit" size={iconSize} />}
          </>
        )}
      </ContentOverlay>
    </Button>
  );
};

export default ButtonLoad;